/**
 * @Author: v_jppjpeng
 * @Date: 2025-04-11 17:31:50
 * @Explain: 用户旅程
 */
import http from '../http';

const MODEL = '/journey';

export default {
  // 列表
  getList(data: Record<any, any>) {
    return http.post(`${MODEL}/list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 暂停数据
  getSuspendDetails(data: Record<any, any>) {
    return http.post(`${MODEL}/suspend_details`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 校验名称
  checkName(data: Record<any, any>) {
    return http.post(`${MODEL}/check_name`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取来源列表
  getJourneySourceList(data: Record<any, any>) {
    return http.post(`${MODEL}/sources_list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取来源列表
  getSourceList(data: Record<any, any>) {
    return http.post(`${MODEL}/sources`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取来源列表
  getNewSourceList(data: Record<any, any>) {
    return http.post(`${MODEL}/sources_list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取双重确认订阅 - 特定地点
  getOptInSpecificRegions(data: Record<any, any>) {
    return http.post(`${MODEL}/opt_in_regions`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取发件信息
  getSenderInfo(data: Record<any, any>) {
    return http.post(`${MODEL}/get_sender_info`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 添加
  onAdd(data: Record<any, any>) {
    return http.post(`${MODEL}/add`, data, {
      params: {
        switchReqToUnderline: true,
        // 忽略 rep attributes_default_value 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
        ]),
      },
    });
  },
  // 编辑
  onEdit(data: Record<any, any>) {
    return http.post(`${MODEL}/edit`, data, {
      params: {
        switchReqToUnderline: true,
        // 忽略 rep attributes_default_value 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
        ]),
      },
    });
  },
  // 详情
  getDetails(data: Record<any, any>, switchReqToUnderline = true) {
    return http.post(`${MODEL}/details`, data, {
      params: {
        switchReqToUnderline,
        // 忽略 rep attributes_default_value 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
        ]),
      },
    });
  },
  // 获取旅程偏好统计
  getPreferenceStatistics(data: Record<any, any>, switchReqToUnderline = true) {
    return http.post(`${MODEL}/statistics`, data, {
      params: { switchReqToUnderline },
    });
  },
  // 删除
  onDel(data: Record<any, any>) {
    return http.post(`${MODEL}/delete`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 开始
  onStart(data: Record<any, any>) {
    return http.post(`${MODEL}/start`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 暂停
  onSuspend(data: Record<any, any>) {
    return http.post(`${MODEL}/suspend`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 终止
  onTermination(data: Record<any, any>) {
    return http.post(`${MODEL}/stop`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 检测 联系字段变量是否被删除
  onCheckAttribute(data: Record<any, any>) {
    const ignoreConvertedKey = JSON.stringify(['attributes']);
    return http.post('/task/check_attribute', data, {
      params: {
        switchReqToUnderline: true,
        ignoreConvertedValueKey: ignoreConvertedKey,
        ignoreConvertedKey: ignoreConvertedKey,
      },
    });
  },
};
